import React from 'react';
import { ActionMeta } from 'react-select';
import { Box, Stack, Typography } from '@mui/material';
import { CustomSelect } from '../../../../../ui/custom_react_select/custom_select';
import { TextInput } from '../../../../../ui/input/text_input/text_input';
import { SelectOptions } from '../../../../../utils/types/react_select_types';

type AgeInputProps = {
  label: string;
  selectOptions: SelectOptions[];
  onSelectChange: (
    selectOptions: SelectOptions,
    action: ActionMeta<unknown>
  ) => void;
  selectValue: SelectOptions;
  onTextChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  textValue: string;
  placeholder?: string;
  min: string;
  max: string;
  disabled?: boolean;
};

export const RangeSelectInput: React.FC<AgeInputProps> = ({
  label,
  selectOptions,
  onSelectChange,
  selectValue,
  onTextChange,
  textValue,
  placeholder,
  min,
  max,
  disabled = false,
}) => {
  return (
    <Stack direction="row" spacing={1.5} alignItems="flex-start">
      <Box sx={{ width: 160 }}>
        <Typography variant="body2" color="text.primary" sx={{ py: 0.5 }}>
          {label}
        </Typography>
        <CustomSelect
          name={label}
          options={selectOptions}
          onChange={onSelectChange}
          value={selectValue}
          disabled={disabled}
        />
      </Box>
      <Box sx={{ width: 160, mt: '28px !important' }}>
        <TextInput
          name={label.toLowerCase() + 'Number'}
          value={textValue}
          type="number"
          onChange={onTextChange}
          placeholder={placeholder}
          min={min}
          max={max}
          disabled={disabled}
        />
      </Box>
    </Stack>
  );
};
